import React from 'react'
import Navbar from "../components/Navbar"
import NotFoundHero from '../components/NotFound'
import Footer from "../components/Footer"
import { useLocation } from 'react-router-dom'


function NotFound() {


  const { pathname } = useLocation();
    React.useEffect(() => {
    window.scrollTo({
      top: 0,
      left: 0,
      behavior: "instant" // use "smooth" if you want animation
    });
  }, [pathname]);
  
  return (
    <>
        <Navbar />
        <NotFoundHero />
        <Footer />
    </>
  )
}

export default NotFound